export default __webpack_public_path__ + "static/media/DSC_9088-thumb.13a3bb34.jpg";